import axios from "../utils/axios.wrapper";

export const walkInSale = async (payload) => {
  const { data } = await axios.post("/mealreservation/walk-in", payload);
  return data;
};

export const mealReservationService = { 
  walkInSale 
};